/* =============================================================
   AVM Herbals — UI micro-interactions (vanilla, deferred)
   - Scroll-reveal for .avm-reveal elements (IntersectionObserver)
   - Sticky-header shadow toggle on scroll
   Respects prefers-reduced-motion.
   Load deferred:  <script src="{{ 'avm-ui.js' | asset_url }}" defer></script>
   ============================================================= */
(function () {
  'use strict';

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // 1. Scroll reveal
  var revealEls = document.querySelectorAll('.avm-reveal');
  if (reduce || !('IntersectionObserver' in window)) {
    revealEls.forEach(function (el) { el.classList.add('is-visible'); });
  } else {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12 });
    revealEls.forEach(function (el) { io.observe(el); });
  }

  // 2. Sticky-header shadow
  var header = document.querySelector('.section-header, .header-wrapper, header.header');
  if (header) {
    var onScroll = function () {
      header.classList.toggle('avm-scrolled', window.scrollY > 8);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  // 3. Privacy-safe commerce and recovery events. Never attach form values,
  // product details, search terms, or consultation/quiz answers.
  var trackSafeEvent = function (eventName, source) {
    var detail = { event: eventName, source: source };
    document.dispatchEvent(new CustomEvent('avm:analytics-event', { detail: detail }));
    if (Array.isArray(window.dataLayer)) {
      window.dataLayer.push({ event: eventName, source: source });
    }
  };

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
      if (event && (event.source === 'product-form' || event.source === 'avm-cart')) {
        trackSafeEvent('avm_add_to_cart', event.source);
      }
    });
  }

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!(form instanceof HTMLFormElement)) return;

    var submitter = event.submitter;
    var checkoutControl =
      (submitter && submitter.getAttribute('name') === 'checkout') ||
      form.querySelector('[name="checkout"]');
    if (checkoutControl) trackSafeEvent('avm_checkout_started', 'cart');
  }, true);

  document.addEventListener('avm:predictive-search-failed', function () {
    trackSafeEvent('avm_search_failed', 'predictive-search');
  });

  // Count direct WhatsApp clicks without sending the message or product details.
  // Preserve only safe storefront context on the way to the consultation form.
  document.addEventListener('click', function (event) {
    if (!(event.target instanceof Element)) return;
    var whatsappLink = event.target.closest('a[href^="https://wa.me/"]');
    if (whatsappLink) {
      var whatsappSource = whatsappLink.dataset.whatsappSource === 'product-page' ? 'product-page' : 'storefront';
      trackSafeEvent('avm_whatsapp_click', whatsappSource);
      if (typeof window.gtag === 'function') {
        window.gtag('event', 'avm_whatsapp_click', { source: whatsappSource, transport_type: 'beacon' });
      }
    }
    var consultationLink = event.target.closest('[data-avm-consultation-link]');
    if (!consultationLink) return;

    var source = (consultationLink.dataset.consultationSource || 'storefront')
      .replace(/[^a-z0-9-]/gi, '-')
      .slice(0, 80);
    var product = (consultationLink.dataset.consultationProduct || '').trim().slice(0, 160);

    try {
      window.sessionStorage.setItem('avmConsultationSource', source);
      if (product) {
        window.sessionStorage.setItem('avmConsultationProduct', product);
      } else {
        window.sessionStorage.removeItem('avmConsultationProduct');
      }
    } catch (error) {
      // Storage may be unavailable in strict privacy modes; navigation still works.
    }
  });
})();
